import { DefaultPageHeader } from 'layouts';
import { usePermissions } from 'permissions';
import { AdminConsoleButton } from 'features/admin-dashboard';
import { JoinedOrganizationsList } from './joined-organizations-list';

type P = { getPathToOrganizationDetail: (id: string) => string };

const JoinedOrganizations = ({ getPathToOrganizationDetail }: P) => {
  const { canViewAdminDashboardOrganizations } = usePermissions();

  return (
    <>
      <DefaultPageHeader
        extra={canViewAdminDashboardOrganizations({}) ? <AdminConsoleButton entityType="organization" /> : null}
        title="Organizations"
      />

      <JoinedOrganizationsList getPathToOrganizationDetail={getPathToOrganizationDetail} />
    </>
  );
};

export default JoinedOrganizations;
